<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>LCL화물운송</h3>
				<h4>LCL 화물운송 안내</h4>
			</div>
			<div class="container">
				<h5><span>01.</span> LCL 수입화물 운송요금 안내</h5>
				<div class="unit">
					<strong>LCL (Less than Container Load) <br class="visible-xs">운송 요금 안내</strong>
					<el-row class="unit-item">
						<el-col :xs="24" :sm="12" >
							<img src="../../assets/list/lcl-img1.png" alt="1cbm이란?" loading="lazy">
						</el-col>
						<el-col :xs="24" :sm="12">
							<div class="item-content">
								<p>1CBM이란?</p>
								<p>
									컨테이너 안에 적재하는 박스의 부피 단위로<br>
									<strong>가로 1M X 세로 1M X 높이 1M의 값이 1CBM</strong>입니다.
								</p>
							</div>
						</el-col>
					</el-row>
					
					<p class="background-color">중국 대량 수입 진행을 이한 사업자 통관 - LCL 화물</p>
					<span>LCL 사업자 통관 시 아래 사항을 참조 바랍니다.</span>
					<el-row style="margin: 47px 0 0;">
						<el-col :xs="12" :sm="6" >
							<div class="text-center">
								<span class="num">1</span>
								최초 진행 시 유니패스에<br class="hidden-xs">
								사업자 통관고유부호 등록
							</div>
						</el-col>
						<el-col :xs="12" :sm="6" >
							<div class="text-center">
								<span class="num">2</span>
								상품 주문 시 상품에 원산지<br class="hidden-xs">
								표기 (made in china) 요청
							</div>
						</el-col>
						<el-col :xs="12" :sm="6" >
							<div class="text-center">
								<span class="num">3</span>
								박스 외부에 쉬핑 마크 요청<br class="hidden-xs">
								(박스 내부에 무엇이 들어있는지 표기)
							</div>
						</el-col>
						<el-col :xs="12" :sm="6" >
							<div class="text-center">
								<span class="num">4</span>
								수취인이 회사인 경우,<br class="hidden-xs">
								수취 회사 사업자로 신청서 접수
							</div>
						</el-col>
					</el-row>
				</div>
				
				<h5 style="padding:80px 0 20px;"><span>02.</span> 요금표</h5>
				<div class="unit">
					<table>
						<colgroup>
							<col v-if="!isMobile" width="200">
							<col v-else width="150">
							<col width="">
						</colgroup>
						<tbody>
							<tr>
								<th>구분</th>
								<td class="background-color">웨이하이</td>
							</tr>
							<tr>
								<th>1CBM</th>
								<td class="background-color">76,000원</td>
							</tr>
							<tr>
								<th>추가 0.1 CBM 당</th>
								<td class="background-color">7,600원</td>
							</tr>
							<tr>
								<th>D/O (화물인도지시서)</th>
								<td class="background-color">19,000원</td>
							</tr>
							<tr>
								<th>선적 작업비용</th>
								<td class="background-color">기본 1cbm까지 9,000원 추가 0.1cmb당 900원</td>
							</tr>
							<tr>
								<th>선적항 운송료</th>
								<td class="background-color">기본 1cbm까지 9,000원 추가 0.1cmb당 900원</td>
							</tr>
							<tr>
								<th>C/O (원산지 증명서)</th>
								<td class="background-color">35,000원
									<!-- <router-link to="/" class="link-btn">
										주의사항 바로가기 <i class="el-icon-top-right"></i>
									</router-link> -->
								</td>
							</tr>
							<tr>
								<th>관세사 수수료</th>
								<td class="background-color">30,000원 (부가세 별도)</td>
							</tr>
							<tr>
								<th>관부가세</th>
								<td class="background-color">사업자 회원 납부</td>
							</tr>
							<tr>
								<th>한국 내 물류비용</th>
								<td class="background-color">사업자 회원 납부 (실비)</td>
							</tr>
							<tr>
								<th>한국 보세창고비용</th>
								<td class="background-color">실비</td>
							</tr>
							<tr>
								<th>중국 수출환급</th>
								<td class="background-color">48,000원 
									<!-- <router-link to="/" class="link-btn">
										주의사항 바로가기 <i class="el-icon-top-right"></i>
									</router-link> -->
								</td>
							</tr>
						</tbody>
					</table>
					<p class="text-center-p background-color" style="margin-top: 10px; font-size: 15px;font-weight: normal;">
						요금 청구 기준: 부피무게 CBM/ 선적 작업비용/ 선적항 운송료 등은 최소 1CBM부터 청구됩니다.<br>
						포장 당 부피와 총 부피 기준으로 소수점 세 자리 이하부터 절상 청구됩니다.<br>
						예: ( 0.123 cbm - &gt; 0.13cbm)
					</p>
					<div class="btn-wrap">
						<router-link to="/bizAddService" class="link-btn2 type-2">
							부가 서비스 바로가기 <i class="el-icon-top-right"></i>
						</router-link>
					</div>
				</div>
				<h5 style="padding:80px 0 20px;"><span>03.</span> 안내</h5>
				<div class="unit background-color">
					<ol>
						<li>
							한중 FTA 세율 수입 총금액 $700 이하 시 자동적용 선택 가능
							<router-link to="/questionList" class="link-btn">
								적용품목 바로가기 <i class="el-icon-top-right"></i>
							</router-link>
							<ul>
								<li>$700 이하의 수입 시 한중FTA에 따른 세율을 적용 가능합니다.</li>
								<li>원산지 증명서는 한중FTA 세율적용 시 세관의 의무제출은 아니지만 제출요청 시 원산지 증명서를 제출하여야 합니다.
									<!-- <router-link to="/" class="link-btn">
										주의사항 바로가기 <i class="el-icon-top-right"></i>
									</router-link> -->
								</li>
							</ul>
						</li>
						<li>수입 전 반드시 수입 가능 / 인증 여부를 확인하시고 진행해주세요.</li>
						<li>판매자로부터 인보이스, 패킹리스트를 제공받으셨다면 고로켓고에게 제공해주세요.<br>
							인보이스, 패킹리스트 제공 불가 시 고객센터로 문의주세요.
						</li>
						<li>세관 수입 신고된 내용과 달리 허위 불성실 기재, 수입 불가 상품 진행 등 발생한 모든 책임은 신청자 본인에게 있습니다.</li>
						<li>포장 완료 후 배송 스케줄에 따라 선적되므로 출고 날짜를 임의로 변경할 수 없습니다.</li>
						<li>수입하시는 모든 물품에는 반드시 원산지 작업 Made in china 표기가 되어 있어야 합니다.<br>
							원산지 증명서가 있으신 경우, 배송비 결제 전까지 고객센터로 제출 바랍니다.
						</li>
						<li>LCL 화물운송은 최소 1CBM 부터 진행가능하며 1CBM 미만일 경우 1CBM 으로 요금적용 됩니다.<br>
							항공화물의 경우 고객센터로 문의 바랍니다.
						</li>
						<li>고로켓고은 국내 외 온라인쇼핑몰에 판매/겸업을 하지 않습니다. 회원님의 소싱/판매 아이템 정보 보호를 최우선으로 합니다.</li>
					</ol>
					<div style="font-weight: bold;">
						사업자 통관 최초 진행 시 위임장 제출바랍니다.<br class="visible-xs">
						<router-link to="/questionList" class="link-btn">
							위임장 및 인보이스 양식 <i class="el-icon-top-right"></i>
						</router-link>
					</div>
				</div>
				
				<div style="text-align: center;" >
					<router-link to="/agencyShipping" class="register-button">
						운송 신청하기
					</router-link>
				</div>
				
			</div>
		</div>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import { safePush } from '@/utils/router';
	export default {
		components: {
			BusinessBanner,
		},
		data() {
			return{
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},		
		methods: {
			onNav(url){
				safePush(this.$router, url);
			}
		}
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--front-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--main-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.container{
		margin: 0 10px;
	}
	.container h5 {
	    font-size: 24px;
	    font-weight: bold;
	    margin-bottom: 18px;
		
	}
	.container h5 span {
	    color: var(--main-color);
	}
	.container .unit{
		padding: 48px 60px 50px;
		background: #fff;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
		border-radius: 30px;
	}
	.unit > strong {
	    font-size: 24px;
		color:var(--background-color)
	}
	.unit .unit-item{
		background-color: #f8f8f8;
		padding: 50px 150px 40px 240px;
		margin-top: 16px;
		margin-bottom: 48px;
	color: var(--background-color); 
	}
	.item-content p:nth-child(1){
		display: block;
		font-size: 20px;
		font-weight: bold;
		border-bottom: 1px solid #dadada;
		padding-bottom: 6px;
		margin-bottom: 5px;
	}
	.item-content p:nth-child(2){
		font-size: 17px;
		line-height: 30px;
	}
	.unit > p {
	    font-size: 20px;
	    font-weight: 600;
	    text-align: center;
	    margin-bottom: 13px;
	}
	.unit > span {
	    display: block;
	    font-size: 15px;
	    text-align: center;
	    color: #274A80;
	}
	.text-center{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: #f5f6fb;
		padding: 20px 0 18px;
		font-size: 15px;
		color: #494F5C;
		border-radius: 10px;
		line-height: 22px;
		margin: 0 10px;
	}
	.text-center .num {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    background: #494F5C;
	    width: 24px;
	    height: 24px;
	    border-radius: 50%;
	    font-size: 15px;
	    color: #fff;
	    line-height: 16px;
		margin-bottom: 25px;
	}
	table {
	    background-color: transparent;
	}
	table th {
		font-weight: bold;
		color: #274A80;
		font-size: 16px;
		padding: 5px 0;
		text-align: left;
	}
	table td {
	    font-size: 16px;
	    padding: 5px 0;
		text-align: left;
	}
	.unit ol {
	    padding: 0 0 0 16px;
	}
	.unit ol > li {
	    font-size: 16px;
	    margin-bottom: 12px;
	    padding-left: 5px;
	    line-height: 32px;
		text-align: left;
	}
	.unit ol li::marker {
	    color: #274A80;
	}

		
	
	.register-button{
		margin-top: 50px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		min-width: 180px;
		margin-bottom: 40px;
		height: 64px;
		border: 1px solid var(--main-color);
		background: var(--main-color);
		border-radius: 36px;
		font-weight: 500;
		font-size: 17px;
		text-decoration: none !important;
		color: #fff !important;
		transition: 0.25s;
		cursor: pointer;
	}
	
	.btn-wrap{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.link-btn{
		border-radius: 20px;
		margin-left: 5px;
		padding: 5px;
		font-weight: 600;
		font-size: 12px;
		line-height: 18px;
		background: #F4F8FF;
		filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
		border: none;
		color: var(--main-color);
		cursor: pointer;
	}
	.link-btn:hover {
	    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
	}
	.link-btn2{
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 30px;
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 13px 28px;
		transition: 0.25s;
		line-height: normal;
		cursor: pointer;
	}
	.link-btn2.type-2{
		color: var(--main-color);
		background: #fff;
	}
	.visible-xs {
	    display: none !important;
	}
	.background-color{
		color:var(--background-color)
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.container .unit{
			padding: 15px 20px ;
		}
		.unit strong {
		    font-size: 15px;
		}
		.unit .unit-item{
			padding: 50px 0 40px;
			text-align: center;
		}
		.item-content{
			text-align: left;
			padding: 10px;
		}
		.unit > p {
		    font-size: 15px;
		}
		.unit > span {
		    font-size: 13px;
		}
		.text-center{
			padding: 20px 5px 18px;
			margin: 0 5px 10px;
		}
		table th,table td {
		    font-size: 13px;
		}
		
		.visible-xs {
		    display:block !important;
		}
		.hidden-xs {
			display: none !important;
		}
	}
	
</style>